<fv-modal #modal [size]="FV_MODAL_SIZE.xs" [modalPosition]="FV_MODAL_POSITION.center" [opaqueBackground]="false"
  [isBackgroundCloseModal]="true" [showIconClose]="false" [footerPosition]="FV_MODAL_FOOTER_POSITION.start"
  [externalPadding]="FV_MODAL_EXTERNAL_PADDING_SIZE.xxs" (isOpenChange)="onOpenChange($event)">
  <div header class="w-full">
    <div class="flex items-center gap-2">
      <i *isMobile class="far fa-arrow-left cursor-pointer" (click)="close()"></i>
      <span class="text-2xl font-semibold"> {{ 'cash_keyboard_modal.title' | translate}}</span>
    </div>
  </div>
  <div body class="flex flex-col justify-center gap-4">
    <div class="p-4 bg-zinc-100 dark:!bg-zinc-700 flex flex-col gap-4 rounded-lg">
      <div class="inline-flex justify-between items-center">
        <span class="text-xl sm:!text-xl text-zinc-900 dark:!text-zinc-50">{{ 'global.total' | translate}}</span>
        <span class="text-2xl sm:!text-5xl font-semibold text-green-300  dark:!text-green-300">
          {{ presenter.viewModel().totalToPay }} {{ data?.currencySymbol }}
        </span>
      </div>
      <div class="inline-flex justify-between items-center">
        <span class="text-xl  sm:!text-xl text-zinc-900 dark:!text-zinc-50">{{ 'global.change' | translate}}</span>
        <span class="text-2xl sm:!text-5xl font-semibold text-blue-300 dark:!text-blue-300">
          {{ presenter.viewModel().change }} {{ data?.currencySymbol }}
        </span>
      </div>
    </div>

    <div class="p-4 bg-zinc-100 dark:!bg-zinc-700 flex flex-col gap-4 rounded-lg mb-2">
      <div #delivered class="inline-flex justify-between items-center">
        <span class="text-xl sm:!text-xl text-zinc-900 dark:!text-zinc-50">{{ 'global.delivered' | translate}}</span>
        <span class="text-2xl sm:!text-5xl font-normal text-zinc-900 dark:!text-zinc-50">
          {{ presenter.viewModel().deliveredAmount }} {{ data?.currencySymbol }}
        </span>
      </div>
    </div>

    <div class="flex w-full">
      <div #board class="flex-wrap flex-grow grid grid-cols-3 items-center justify-center font-semibold dark:!bg-zinc-900 bg-zinc-100 text-zinc-400 dark:!text-zinc-400 rounded-md">
        <span (click)="presenter.appendDigit(number)" class="flex items-center justify-center text-2xl sm:!text-2xl md:!text-base lg:!text-2xl xl:!text-2xl
         p-4 sm:!p-4 sm:!py-4 md:!p-2 lg:!p-3 xl:!p-4
        cursor-pointer select-none" *ngFor="let number of numbers; trackBy: trackByNumber">
          {{number}}
        </span>
        <span (click)="presenter.appendDecimalSeparator()" class="flex items-center justify-center text-2xl sm:!text-2xl md:!text-base lg:!text-2xl xl:!text-2xl
        p-4 sm:!p-4 sm:!py-4 md:!p-2 lg:!p-3 xl:!p-4
        cursor-pointer select-none rounded-bl-md">,</span>
        <span (click)="presenter.appendDigit(0)" class="flex items-center justify-center text-2xl sm:!text-2xl md:!text-base lg:!text-2xl xl:!text-2xl
        p-4 sm:!p-4 sm:!py-4 md:!p-2 lg:!p-3 xl:!p-4
        cursor-pointer select-none font-semibold">0</span>
        <span (click)="presenter.deleteLastDigit()" class="flex items-center justify-center text-2xl sm:!text-2xl md:!text-base lg:!text-2xl xl:!text-2xl
        p-4 sm:!p-4 sm:!py-4 md:!p-2 lg:!p-3 xl:!p-4
        cursor-pointer  h-full  rounded-br-md"><i class="fal fa-delete-left select-none"></i></span>
      </div>
      <div #auxButtons>
        <ng-content select="[auxButtons]"></ng-content>
      </div>
    </div>

    <div [ngClass]="{'mb-10': isMobile}">
      <fv-button id="cash" data-cy="close-account" class="w-full" [size]="BUTTON_SIZE.full" [type]="BUTTON_TYPE.filled"
        [disabled]="!presenter.viewModel().isValid" [color]="BUTTON_COLOR.success" [variant]="BUTTON_VARIANT.default"
        (click)="onClickSubmit()">{{'cash_keyboard_modal.submit_button' | translate}}</fv-button>
    </div>
  </div>
</fv-modal>
